import { render } from "./Itemedit4exmedia.vue?vue&type=template&id=47dc7234&scoped=true&ts=true"
import script from "./Itemedit4exmedia.vue?vue&type=script&lang=ts"
export * from "./Itemedit4exmedia.vue?vue&type=script&lang=ts"

import "./Itemedit4exmedia.vue?vue&type=style&index=0&id=47dc7234&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47dc7234"]])

export default __exports__